import { useInfiniteQuery, type InfiniteData, type UseInfiniteQueryResult } from '@tanstack/react-query';
import { fetchControlSystemOptionsPage } from '../../request/controls/controlItgcOptions.ts';

export const controlSystemOptionsQueryKey = (search: string) =>
  ['controls', 'system-options', search] as const;

export type ControlSystemOptionsPageView = Awaited<ReturnType<typeof fetchControlSystemOptionsPage>>;

export function useControlSystemOptions(
  search: string,
  enabled = true
): UseInfiniteQueryResult<InfiniteData<ControlSystemOptionsPageView>, Error> {
  return useInfiniteQuery({
    queryKey: controlSystemOptionsQueryKey(search),
    enabled,
    staleTime: 0,
    refetchOnMount: 'always',
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      fetchControlSystemOptionsPage({ page: Number(pageParam) || 1, pageSize: 20, search }),
    getNextPageParam: (lastPage) => {
      const items = lastPage.items;
      if (!Array.isArray(items) || items.length === 0) return undefined;
      const pageSize = lastPage.pageSize || 20;
      if (lastPage.isLastPage === true) return undefined;
      if (lastPage.isLastPage == null && items.length < pageSize) return undefined;
      const page = typeof lastPage.page === 'number' && Number.isFinite(lastPage.page) ? lastPage.page : 1;
      return page + 1;
    },
  });
}
